<template>
  <div
    class="v3-form behaviour-delete-positive-behaviour-form"
    data-testid="behaviour-delete-positive-behaviour-form"
  >
    <p
      class="behaviour-delete-positive-behaviour-form__message text-muted mb-3"
    >
      {{
        $t("behaviour_settings.delete_positive_behaviour_message", {
          name: positiveBehaviourName,
          positiveBehaviours: behaviourTerminology.positiveBehaviours
        })
      }}
    </p>

    <div class="text-center">
      <LoadingButton
        class="me-2 px-4"
        type="button"
        rounded
        data-testid="behaviour-pb-delete-cancel"
        @click="onCancel"
      >
        {{ $t("common.cancel") }}
      </LoadingButton>
      <LoadingButton
        class="px-4 behaviour-delete-positive-behaviour-form__delete-btn"
        type="button"
        solid
        rounded
        :is-loading="state.isProcessing"
        :disabled="state.isProcessing"
        data-testid="behaviour-pb-delete-confirm"
        @click="onDelete"
      >
        {{ $t("behaviour_settings.delete_positive_behaviour_confirm") }}
      </LoadingButton>
    </div>
  </div>
</template>

<script>
import useAppToast from "@/composables/useAppToast.js"
import { parsePositiveBehaviourApiError } from "@/helpers/behaviourPositiveBehaviourForm.js"
import LoadingButton from "@/v3components/shared/Buttons/LoadingButton.vue"
import { computed, inject, nextTick, reactive } from "vue"
import { useI18n } from "vue-i18n"
import { useStore } from "vuex"

export default {
  name: "BehaviourDeletePositiveBehaviourForm",
  components: {
    LoadingButton
  },
  props: {
    positiveBehaviour: {
      type: Object,
      required: true
    }
  },
  emits: ["cancel"],
  setup(props, { emit }) {
    const { t } = useI18n()
    const store = useStore()
    const modal = inject("modal")
    const toast = useAppToast()

    const behaviourTerminology = computed(
      () => store.getters["behaviourSettings/behaviourTerminology"]
    )

    const positiveBehaviourName = computed(
      () => props.positiveBehaviour?.name || ""
    )

    const state = reactive({
      isProcessing: false
    })

    const onCancel = () => {
      emit("cancel")
    }

    const onDelete = async () => {
      if (!props.positiveBehaviour?.id) return

      try {
        state.isProcessing = true
        await store.dispatch(
          "behaviourSettings/deletePositiveBehaviour",
          props.positiveBehaviour.id
        )
        modal?.setAction?.("positiveBehaviourDeleted", {
          id: props.positiveBehaviour.id
        })
        // Let the parent watcher observe `action`/`actionData` before
        // `modal.close()` resets `modal.options`.
        await nextTick()
        emit("cancel")
      } catch (error) {
        const parsed = parsePositiveBehaviourApiError(error)
        toast.error(
          parsed.message ||
            t("behaviour_settings.delete_positive_behaviour_error", {
              positiveBehaviours: behaviourTerminology.value.positiveBehaviours
            })
        )
      } finally {
        state.isProcessing = false
      }
    }

    return {
      behaviourTerminology,
      positiveBehaviourName,
      state,
      onCancel,
      onDelete
    }
  }
}
</script>
